<template>
    <div class="waf-component waf-breadcrumb widget-layout-03">
        <div class="layout-wrapper">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb" itemscope="" itemtype="https://schema.org/BreadcrumbList">
                    <li
                        v-for="(b, idx) in getLevels()"
                        v-bind:key="idx"
                        itemprop="itemListElement"
                        itemscope=""
                        itemtype="https://schema.org/ListItem"
                    >
                        <a itemprop="item" :href="b.link">
                            <span itemprop="name">{{b.name}}</span>
                        </a>
                        <meta itemprop="position" :content="(idx+1)" />
                    </li>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script>
import { getMatchInfoTitle, urlCorrections, toTitleCase } from '../../assets/js/common';
import { CFG_MODULES, CFG_PAGES, CFG_WIDGET_URL_BASE, SPORT_LIST } from '../../assets/js/config';

export default {
    props: ["parentRoute", "current_match", "titleTrans", "currentSeriesObj", "currentSeries", "sequence"],
    methods: {
        getLevels() {
            let params = this.$route && this.$route.params;
            let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hi/");
            let homeLink = CFG_WIDGET_URL_BASE;
            if(this.sequence) {
                let totalLink = "";
                let arr = [];
                this.sequence.map(mo => {
                    if(mo.type == "base") {
                        /* home page */
                        let homeSlice = this.getHomeSlice(homeLink);
                        if(homeSlice) {
                            totalLink = mo.isforceSlice ? totalLink : `${totalLink}${isHindi ? '/hi' : ''}`;
                            arr.push(homeSlice);
                        }
                    } else if(mo.type == 'module') {
                        /* tab page */
                        let moduleSlice = null;
                        if(mo.module) {
                            moduleSlice = this.getModuleSlice(totalLink, mo.module);
                        } else {
                            moduleSlice = this.getModuleSlice(totalLink, this.parentRoute);
                        }
                        if(moduleSlice) {
                            totalLink = mo.isforceSlice ? totalLink : moduleSlice.newLink;
                            if(!mo.blockSlice) {
                                arr.push(moduleSlice.slice);
                            }
                        }
                    } else if(mo.type == 'param') {
                        let p = params[mo.param];
                        if(mo.param == 'sport_name') {
                            /* sport */
                            if(p){
                                let sportSlice = this.getSportSeriesSlice(totalLink, p, false);
                                if(sportSlice){
                                    totalLink = mo.isforceSlice ? totalLink : sportSlice.newLink;
                                    if(!mo.blockSlice) {
                                        arr.push(sportSlice.slice);
                                    }
                                }
                            } else {
                                if(params.slug && this.current_match) {
                                    totalLink = mo.isforceSlice ? totalLink : `${totalLink}${this.current_match.sport_name}`
                                    if(!mo.blockSlice){
                                        arr.push({
                                            name: toTitleCase(this.current_match.sport_name),
                                            link: urlCorrections(totalLink),
                                        });
                                    }
                                }
                            }
                        } else {
                            /* series */
                            if(p) {
                                let seriesSlice = this.getSportSeriesSlice(totalLink, p, false);
                                if(seriesSlice){
                                    totalLink = mo.isforceSlice ? totalLink : seriesSlice.newLink;
                                    if(!mo.blockSlice) {
                                        arr.push(seriesSlice.slice);
                                    }
                                }
                            }
                        }
                    } else if(mo.type == 'page') {
                        /* custom pages */
                        let pageObj = CFG_PAGES[mo.page];
                        if(pageObj) {
                            totalLink = mo.isforceSlice ? totalLink : `${totalLink}${pageObj.route}`; 
                            let title = pageObj.breadcrumbName;
                            if(!mo.blockSlice) {
                                arr.push({
                                    name: title,
                                    link: urlCorrections(totalLink)
                                })
                            }
                        }
                    } else if(mo.type == 'title') {
                        /* title */
                        let titleSlice = this.getTitleSlice(totalLink, params, isHindi);
                        if(titleSlice) {
                            totalLink = mo.isforceSlice ? totalLink : titleSlice.newLink;
                            if(!mo.blockSlice) {
                                arr.push(titleSlice.slice);
                            }
                        }
                    }
                });

                if(arr && arr.length) {
                    arr[arr.length-1].link = null; // removing link from last element
                }

                return arr;
            } else {
                return [];
            }
        },
        findModule(moduleRoute) {
            let module = null;
            for(let i in CFG_MODULES){
                if(CFG_MODULES[i].route === moduleRoute){
                    module = CFG_MODULES[i];
                }
            }
            return module;
        },
        getHomeSlice(totalLink) {
            return {
                name: toTitleCase("home"),
                link: urlCorrections(totalLink),
            }
        },
        getModuleSlice(totalLink, moduleRoute) {
            let module = this.findModule(moduleRoute);
            if(module) {
                let newLink = urlCorrections(`${totalLink}${module.route}`); 
                return {
                    newLink,
                    slice: {
                        name: toTitleCase(module.breadcrumbName),
                        link: newLink,
                    }
                }
            } else {
                return null;
            }
        },
        getTitleSlice(totalLink, params, isHindi) {
            if(params.slug && this.current_match){
                let newLink = `${totalLink}/${params.slug}`; 
                let title = getMatchInfoTitle(this.current_match, this.titleTrans, false, isHindi);
                return {
                    newLink,
                    slice: {
                        name: title,
                        link: urlCorrections(newLink),
                    }
                }
            } else {
                return null;
            }
        },
        getSportSeriesSlice(totalLink, entity, isSeriesListing) {
            if(this.currentSeries && this.currentSeries != -1) {
                let sName = (this.currentSeriesObj && this.currentSeriesObj.category_name || '');
                let newLink = `${totalLink}/${entity}`;                
                return {
                    newLink,
                    slice: {
                        name: toTitleCase(sName),
                        link: urlCorrections(newLink),
                    }
                }
            } else {
                if(isSeriesListing) {
                    return null;
                } else {
                    let trimmedSeriesSlug = entity.split('-series-')[0];
                    let sportInSlug = trimmedSeriesSlug.split('-')[0];
                    let isSportAvailable = SPORT_LIST.find(s => s.name.toLocaleLowerCase() == sportInSlug.toLocaleLowerCase());
                    if(isSportAvailable) {
                        trimmedSeriesSlug = trimmedSeriesSlug.replace(`${sportInSlug}-`, '');
                    }
                    let newName = trimmedSeriesSlug.replace(/-/g, ' ');

                    let newLink = `${totalLink}/${entity}`;
                    return {
                        newLink,
                        slice: {
                            name: toTitleCase(newName),
                            link: urlCorrections(newLink),
                        }
                    }
                }
            }
        }
    }
}
</script>